<div data-testid="app-marketplace" class="home">
  <realwear-cloud-top-bar></realwear-cloud-top-bar>

  <realwear-cloud-marketplace-header></realwear-cloud-marketplace-header>

  <div class="content">
    <ng-container *ngIf="category === '' || category === 'featured'; else other">
      <realwear-cloud-category-featured></realwear-cloud-category-featured>
    </ng-container>
    <ng-template #other>
      <realwear-cloud-category-viewer [category]="category"></realwear-cloud-category-viewer>
    </ng-template>
  </div>
  <realwear-cloud-footer></realwear-cloud-footer>
</div>
